import {apiClient} from './apiClient';
import type {ProviderOrder} from '@/types/api';

export interface ProviderOrdersResponse {
    orders: ProviderOrder[];
}

export interface ProviderOrderSearchRequest {
    oid?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    limit?: number;
}

export interface ProviderSalesPoint {
    date: string;
    label: string;
    salesAmount: number;
    ordersCount: number;
}

export interface ProviderSalesReportResponse {
    range: 'last7' | 'month' | 'year' | 'custom';
    startDate: string;
    endDate: string;
    salesThisPeriod: number;
    avgDailySales: number;
    ordersPlaced: number;
    conversionRate: number | null;
    series: ProviderSalesPoint[];
}

interface ProviderOrderParams {
    orgId?: number;
    limit?: number;
}

interface ProviderSalesParams {
    orgId?: number;
    range?: ProviderSalesReportResponse['range'];
    from?: string;
    to?: string;
}

export const ProviderConsoleService = {
    async getPatientOrders(params: ProviderOrderParams = {}): Promise<ProviderOrdersResponse> {
        return apiClient.get<ProviderOrdersResponse>('/api/provider/orders', {
            params,
        });
    },

    async searchPatientOrders(body: ProviderOrderSearchRequest): Promise<ProviderOrdersResponse> {
        return apiClient.post<ProviderOrdersResponse>('/api/provider/orders/search', body);
    },

    async getSalesReport(params: ProviderSalesParams = {}): Promise<ProviderSalesReportResponse> {
        return apiClient.get<ProviderSalesReportResponse>('/api/provider/sales', {
            params,
        });
    },
};
